/**
 * QuarterStatusBadge — zeigt den Quartals-Status (Schema 2.0, D-031 §2.3).
 *  closed   = Quartalsende-SuSa liegt vor (Ist vollständig)
 *  active   = laufend: echte Monate + Hochrechnung (R4-Mix)
 *  forecast = reine Prognose (Q-Soll)
 * Barrierefrei: role="img" + aria-label mit Klartext.
 */
import type { QuarterStatus } from '../types/snapshot';

const LABELS: Record<QuarterStatus, string> = {
  closed: 'Abgeschlossen',
  active: 'Laufend (Ist + Hochrechnung)',
  forecast: 'Prognose',
};

const CLS: Record<QuarterStatus, string> = {
  closed: 'bg-ampel-green/15 text-ampel-green',
  active: 'bg-ampel-yellow/15 text-ampel-yellow',
  forecast: 'bg-ampel-gray/15 text-ampel-gray',
};

export interface QuarterStatusBadgeProps {
  status: QuarterStatus;
  className?: string;
}

export function QuarterStatusBadge({ status, className = '' }: QuarterStatusBadgeProps) {
  return (
    <span
      role="img"
      aria-label={`Quartals-Status ${LABELS[status]}`}
      data-status={status}
      className={`inline-flex items-center rounded px-1.5 py-0.5 text-xs font-medium ${CLS[status]} ${className}`}
    >
      {LABELS[status]}
    </span>
  );
}
